import React, { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../context';
import hasPermission from '../../Shared/hasPermission';
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from 'reactstrap';

const PracticeViewPicker = () => {
    const dispatch = useDispatch();
    // displays which button is clicked; default is "Active"
    const practiceTab = useSelector((state) => state.practice.practiceLink);
    const permissions = useSelector((state) => state.auth.permissions);

    const [isOpen, setIsOpen] = useState(false);
    const isSwapping = useRef(false);

    const canViewDormant = hasPermission(['ViewAllPractices'], permissions);

    const swapTabs = (tab) => {
        if (tab === practiceTab) {
            setIsOpen(false);
            return;
        }
        if (!isSwapping.current) {
            isSwapping.current = true;
            setTimeout(() => {
                dispatch(actions.practice.setActiveTabPractices(tab));
                isSwapping.current = false;
                setIsOpen(false);
            }, 200);
        }
    };

    // TODO: put into db or put into jsx
    const options = [
        {
            value: 'all',
            label: 'All',
            description: 'View all practices',
        },
        {
            value: 'new',
            label: 'New',
            description: 'View new practices',
        },
        {
            value: 'stale',
            label: 'Stale',
            description: 'View practices with current errors',
        },
        {
            value: 'muted',
            label: 'Muted',
            description: 'View muted practices',
        },
        {
            value: 'manual_conversions',
            label: 'Manual Conversions',
            description: 'View manual conversions',
        },
        {
            value: 'conversions',
            label: 'Conversions',
            description: 'View conversion practices',
        },
        {
            value: 'live',
            label: 'Live',
            description: 'View live practices',
        },
        // Only include the dormant option if the user has permission
        ...(canViewDormant
            ? [{
                value: 'dormant',
                label: 'Dormant',
                description: 'View dormant practices',
            }]
            : [])
    ];

    const toggleOpen = () => setIsOpen(!isOpen);

    const firstChar = /^[a-z]/;
    const space = /_[a-z]/;
    const getUppercaseTitle = (value) =>
        value
            .replace(firstChar, (match) => match.toUpperCase())
            .replace(space, (match) => match.toUpperCase().replace('_', ' '));

    return (
        <Dropdown
            className="text-center"
            isOpen={isOpen}
            toggle={toggleOpen}>
            <DropdownToggle
                className="text-center sc-glass"
                color="primary"
                caret
                style={{}}>
                <span className="mx-5">
                    {getUppercaseTitle(practiceTab || '')}
                </span>
            </DropdownToggle>
            <DropdownMenu>
                {options.map((o) => (
                    <DropdownItem
                        key={o.value}
                        title={o.description}
                        onClick={() => swapTabs(o.value)}>
                        {o.label}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default PracticeViewPicker;
